export default __webpack_public_path__ + "static/media/keyboard.fcab8568.jpg";